import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './Authentication.module.css'
import { type AuthenticationDisplay } from './AuthenticationViewModel'

export interface AuthenticationScreenProps {
  display: AuthenticationDisplay
  children: ReactNode
}

export function AuthenticationScreen({
  display,
  children,
}: AuthenticationScreenProps) {
  return <div className={cx(styles.root, styles[display])}>{children}</div>
}

export interface AuthenticationContentProps {
  isLoginVisible: boolean
  landingPageImage: string
  login: ReactNode
  workspaceSignup: ReactNode
  workspaceSelector: ReactNode
  children: ReactNode
}

export function AuthenticationContent({
  isLoginVisible,
  landingPageImage,
  login,
  workspaceSignup,
  workspaceSelector,
  children,
}: AuthenticationContentProps) {
  return (
    <>
      {isLoginVisible && login}
      <div className={styles.image}>
        <img src={landingPageImage} alt="" />
      </div>
      {workspaceSignup}
      {workspaceSelector}
      <div className={styles.navigation}>{children}</div>
    </>
  )
}
